import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import Heading from 'components/heading/heading'
import Btn from 'components/btn/btn'
import BtnGroup from 'components/btn-group/btn-group'
import personalization from 'utils/data/personalization'
import useAppState from 'utils/state'
import { useModal } from 'components/modals/provider'
import { cn, getRoute } from 'utils/helpers'
import styles from './personalization.module.scss'

export default function Personalization({ home, reset, className, hideModal, image }) {
    const { showMessage } = useModal()
    const router = useRouter()
    const { filter, resetFilter, submitFilter } = useAppState()
    const [showLayer, setShowLayer] = useState('main')
    const [values, setValues] = useState({
        group: [],
        price: null,
        like: null
    })

    useEffect(() => {
        if (filter) {
            if (filter.group) {
                setValues(filter)
            }
        }
    }, [filter])

    const { groups, matrix } = personalization

    console.log(personalization)

    const types = [
        {
            name: 'group',
            value: values.group || ['all'],
            options: groups
        },
        {
            name: 'price',
            value: values.price || 'any_price',
            options: [
                {
                    id: 'any_price',
                    name: 'Bet kokia kaina'
                },
                {
                    id: 'under_25',
                    name: 'Mažiau nei 25€'
                },
                {
                    id: '25_50',
                    name: '25€ - 50€'
                },
                {
                    id: '50_100',
                    name: '50€ - 100€'
                },
                {
                    id: 'over_100',
                    name: 'Virš 100€'
                }
            ]
        },
        {
            name: 'like',
            value: values.like,
            options: [
                {
                    id: 'stylish',
                    name: 'Prabanga ir dizainerių darbai'
                },
                {
                    id: 'handmade',
                    name: 'Amatai ir rankų darbas'
                }
            ]
        }
    ]

    const typeValues = {
        group: values.group.length ? values.group : ['all'],
        price: values.price || 'any_price',
        like: null
    }

    // kategorija, kaina, stilius
    types.map(type => {
        const other = ['group', 'price', 'like'].filter(t => t != type.name)
        // kiekvienam mygtukui (M)
        type.options = type.options.map(option => {
            let total = 0
            // kiekvienai kombinacijai
            for (let i = 0; i < matrix.length; i++) {
                // jeigu kombinacijoje yra M
                if (matrix[i][type.name] == option.id) {
                    // stilius/kaina - jei nepasirinkta, arba pasirinkta is esamos kombinacijos
                    if (!typeValues[other[1]] || matrix[i][other[1]] == typeValues[other[1]]) {
                        if (other[0] == 'group') {
                            if (
                                !typeValues[other[0]] ||
                                typeValues[other[0]].indexOf(matrix[i][other[0]].toString()) > -1
                            ) {
                                total += matrix[i].no
                            }
                        } else {
                            if (!typeValues[other[0]] || matrix[i][other[0]] == typeValues[other[0]]) {
                                total += matrix[i].no
                            }
                        }
                    }
                }
            }
            return { ...option, total }
        })
    })

    const groupData = types[0]
    const priceData = types[1]
    const likeData = types[2]

    let groupText = 'Kokioje kategorijoje?'
    let priceText = 'Už kokią kainą?'
    let likeText = 'Kas domina?'
    const groupActive = !!values.group.length
    const priceActive = !!values.price
    const likeActive = !!values.like

    const suggestionsUrl = getRoute('suggestions')

    if (values.price) {
        priceText = priceData.options.find(p => p.id == values.price).name
    }
    if (values.like) {
        likeText = likeData.options.find(l => l.id == values.like).name
    }
    if (values.group.length == 1 && values.group[0] == 'all') {
        groupText = 'Visos kategorijos'
    } else if (values.group.length == 1) {
        groupText = groups.filter(g => values.group[0] === g.id)[0].name
    } else if (values.group.length > 1) {
        groupText = `${values.group.length} kategorijos`
    }

    const handleReset = () => {
        resetFilter(values)
        router.push(suggestionsUrl)
    }

    const handleSubmit = () => {
        if (values.group.length || values.price || values.like) {
            submitFilter(values)
            router.push(`${suggestionsUrl}#r`)
            if (hideModal) {
                hideModal()
            }
        } else {
            showMessage('Užpildykite visus laukelius.')
        }
    }

    const handlePriceSelect = slug => {
        setValues({ ...values, price: slug })
        setShowLayer('main')
    }

    const handleLikeSelect = slug => {
        setValues({ ...values, like: slug })
        setShowLayer('main')
    }

    const handleGroupSelect = id => {
        let group
        if (values.group.indexOf(id) > -1) {
            group = values.group.filter(g => g != id && g != 'all')
        } else {
            group = values.group
            group.push(id)
            group = group.filter(g => g != 'all')
        }
        setValues({ ...values, group })
    }

    const handleAllGroupsSelect = () => {
        setValues({ ...values, group: ['all'] })
        setShowLayer('main')
    }

    return (
        <div className={styles.container}>
            <div className={cn(styles.personalization, image && styles.image, home && styles.home, className)}>
                {showLayer == 'main' && (
                    <div className={styles.layer}>
                        <div>
                            <Heading tag="h1" size="36">
                                {home
                                    ? 'Lietuvos smulkieji gamintojai ir amatininkai vienoje vietoje'
                                    : 'Kokių prekių ieškote?'}
                            </Heading>
                            <p>
                                {home
                                    ? 'Padėti atrasti tai, kas arčiau jūsų širdies?'
                                    : 'Sistema išrinks kūrinius, kurie arčiau jūsų širdies'}
                            </p>
                        </div>
                        <div className={styles.btns}>
                            <Btn
                                className={cn(styles.btn, groupActive && styles.activeMain)}
                                onClick={() => setShowLayer('group')}
                                icon="personalization-group"
                            >
                                {groupText}
                            </Btn>
                            <Btn
                                className={cn(styles.btn, styles.main, priceActive && styles.activeMain)}
                                onClick={() => setShowLayer('price')}
                                icon="personalization-price"
                            >
                                {priceText}
                            </Btn>
                            <Btn
                                className={cn(styles.btn, styles.main, likeActive && styles.activeMain)}
                                onClick={() => setShowLayer('like')}
                                icon="personalization-like"
                            >
                                {likeText}
                            </Btn>
                        </div>
                        <BtnGroup>
                            {reset && (
                                <Btn className={styles.ghost} ghost onClick={handleReset}>
                                    Nustatyti iš naujo
                                </Btn>
                            )}
                            <Btn style="yellow" onClick={handleSubmit}>
                                Gauti pasiūlymus
                            </Btn>
                        </BtnGroup>
                    </div>
                )}
                {showLayer == 'group' && (
                    <div className={styles.layer}>
                        <div>
                            <Heading tag="h2" size="30">
                                Kokioje kategorijoje?
                            </Heading>
                            <p>Pasirinkite kategorijas.</p>
                        </div>
                        <div className={styles.btns}>
                            <Btn
                                className={cn(
                                    styles.btn,
                                    styles.btnCategory,
                                    values.group.indexOf('all') > -1 && styles.active
                                )}
                                onClick={handleAllGroupsSelect}
                            >
                                Visos kategorijos
                                <u>{groupData.options.map(o => o.total).reduce((a, b) => a + b, 0)}</u>
                            </Btn>
                            {groupData.options.map(group => (
                                <Btn
                                    key={group.id}
                                    className={cn(
                                        styles.btn,
                                        styles.btnCategory,
                                        values.group.indexOf(group.id) > -1 && styles.active
                                    )}
                                    onClick={() => handleGroupSelect(group.id)}
                                >
                                    {group.name}
                                    <u>{group.total}</u>
                                </Btn>
                            ))}
                        </div>
                        <Btn style="yellow" onClick={() => setShowLayer('main')}>
                            <span>Tęsti</span>
                        </Btn>
                    </div>
                )}
                {showLayer == 'price' && (
                    <div className={styles.layer}>
                        <div>
                            <Heading tag="h2" size="30">
                                Už kokią kainą?
                            </Heading>
                            <p>Pasirinkite kainos rėžį.</p>
                        </div>
                        <div className={styles.btns}>
                            {priceData.options.map(price => (
                                <Btn
                                    key={price.id}
                                    className={cn(styles.btn, values.price == price.id && styles.active)}
                                    onClick={() => handlePriceSelect(price.id)}
                                >
                                    {price.name}
                                    <u>{price.total}</u>
                                </Btn>
                            ))}
                        </div>
                        <div className={styles.space} />
                    </div>
                )}
                {showLayer == 'like' && (
                    <div className={styles.layer}>
                        <div>
                            <Heading tag="h2" size="30">
                                Kas domina?
                            </Heading>
                            <p>Pasirinkite variantą, kuris labiau tinka tam, ko ieškote.</p>
                        </div>
                        <div className={styles.btns}>
                            {likeData.options.map(like => (
                                <Btn
                                    key={like.id}
                                    className={cn(styles.btn, values.like == like.id && styles.active)}
                                    onClick={() => handleLikeSelect(like.id)}
                                >
                                    {like.name}
                                    <u>{like.total}</u>
                                </Btn>
                            ))}
                        </div>
                        <div className={styles.space} />
                    </div>
                )}
            </div>
        </div>
    )
}
